import { g as r } from "./global.js";
import { f as e } from "./fails.js";
import { e as s } from "./engine-v8-version.js";
import { e as n } from "./engine-is-browser.js";
import { e as o } from "./engine-is-deno.js";
import { e as t } from "./engine-is-node.js";
var i = r.structuredClone,
  a = !!i && !e(function () {
    if (o && s > 92 || t && s > 94 || n && s > 97) return !1;
    var r = new ArrayBuffer(8),
      e = i(r, {
        transfer: [r]
      });
    return 0 != r.byteLength || 8 != e.byteLength;
  });
export { a as s };